import { defineStore } from 'pinia'
import useCustomFetch from '~/composables/useCustomFetch'
import { STATUS_OK } from '~/constants/apiStatus'
import { useUserStore, useModalStore } from '~/stores'

export const useCasinoStore = defineStore('casinoStore', () => {
    const fetcher = useCustomFetch()
    const useUserStoreInstance = useUserStore()
    const useModalStoreInstance = useModalStore()

    const casinoTypes = ref([])

    useFetch('/casino/types', {
        baseURL: '/api/v1',
        onResponse: ({ response }) => {
            if (response.status === 200) {
                const listProvider = response._data.data
                for (let i = 0; i < listProvider.length; i++) {
                    if (listProvider[i].key === 'dragon_tiger') {
                        listProvider[i].key = 'dragontiger'
                        break
                    }
                }
                casinoTypes.value = listProvider.splice(1)
            }
        },
    })

    const casinos = ref([])
    const getCasino = async (queryParams) => {
        try {
            const { data, pending, error } = await fetcher.get(
                '/casino/search/',
                { ...queryParams, limit: 20 }
            )
            if (data.value?.status === STATUS_OK) {
                if (queryParams.page > 1) {
                    casinos.value.items.push(...data.value.data.items)
                } else {
                    casinos.value = data.value.data
                }
            }
            return { data: casinos, pending, error }
        } catch (error) {
            console.log('casinoStore', error)
        }
    }

    const getCasinoUrl = async (queryParams) => {
        if (useUserStoreInstance.isLoggedIn) {
            const { data } = await fetcher.get('/casinoUrl', queryParams)
            if (data.value?.status === 'SHOW_MESSAGE') {
                useModalStoreInstance.showGameDenyModal = true
                return { data: ref(null) }
            } else {
                return { data: data }
            }
        } else {
            useModalStoreInstance.showLoginModal = true
            // return an empty ref
            return { data: ref(null) }
        }
    }
    const weeklyCasinoGames = ref([])
    const getWeeklyCasinoGames = async () => {
        try {
            const { data } = await fetcher.get(
                '/casino/search/?type=all&keyword&partner&filter&page=1&limit=5'
            )

            if (data.value?.status === STATUS_OK) {
                weeklyCasinoGames.value = data.value.data
            }
        } catch (error) {
            console.log('getWeeklyCasinoGames', error)
        }
    }

    return {
        casinoTypes,
        casinos,
        getCasino,
        getCasinoUrl,
        weeklyCasinoGames,
        getWeeklyCasinoGames,
    }
})
